import ItemsTable from '@app/components/LoggedIn/Menu/Items/ItemsList/ItemsTable';
import { IConfirmationModal } from '@app/state/app/types';
import { displayFlexRowStyles } from '@app/theme/commonStyles';
import { IConfirmationModalSimilarItems } from '@westondev/tableturn-core';
import { WithTranslation } from 'react-i18next';
import { accordionSectionStyles } from '../../Accordion/AccordionSection/styles';
import Box from '../../Box';
import Button from '../../Button';
import Icon from '../../Icon';
import { EMPTY_FILTER_PARAMS } from '../../MainScreenWithFilterContainer/initialState';
import Modal from '../../Modal';
import Typography from '../../Typography';
import { btnBaseStyles } from '../styles';

type ISimilarItemsModal = WithTranslation &
  IConfirmationModalSimilarItems &
  Pick<IConfirmationModal, 'btnCancelCsx' | 'btnSuccessCsx'>;

const SimilarItemsModal = ({
  t,
  onSuccess,
  onCancel,
  active,
  items,
  title,
  description,
  btnSuccessText,
  btnCommonCsx: btnCommonCsx,
  btnCancelCsx: btnCancelCsx,
  btnSuccessCsx: btnSuccessCsx,
  btnTerciaryText,
  onTerciaryButtonPress,
}: ISimilarItemsModal) => {
  return (
    <Modal
      isActive={active}
      onModalClose={() => onCancel && onCancel()}
      size="90%"
      title={
        <Box csx={[displayFlexRowStyles, { gap: '10px' }]}>
          <Icon name="MdInfo" color="semanticBlue" size="30px" />
          <Typography variant="heading">{title}</Typography>
        </Box>
      }
      subtitle={<Typography>{description}</Typography>}
      footer={
        <>
          <Button
            csx={[btnBaseStyles, btnCommonCsx, btnCancelCsx]}
            variant="secondary"
            onClick={onCancel}>
            {t('commonButtons.cancel')}
          </Button>
          {btnTerciaryText && (
            <Button
              csx={[btnBaseStyles, btnCommonCsx]}
              variant="secondary"
              onClick={onTerciaryButtonPress}>
              {btnTerciaryText}
            </Button>
          )}
          <Button
            csx={[btnBaseStyles, btnCommonCsx, btnSuccessCsx]}
            variant="primary"
            onClick={onSuccess}>
            {btnSuccessText || t('commonButtons.ok')}
          </Button>
        </>
      }>
      <Box csx={accordionSectionStyles('default', true)}>
        <ItemsTable
          filterParams={EMPTY_FILTER_PARAMS}
          customItems={items}
          onNameClick={onCancel}
          replaceBreadCrumb
          csx={{ padding: 0 }}
          disableItemNameRef
        />
      </Box>
    </Modal>
  );
};

export default SimilarItemsModal;
